module.exports = __webpack_public_path__ + "img/665.7c1da4c8.jpg";